<template>
    <v-dialog
        v-if="isVisible"
        v-model="isVisible"
        transition="dialog-top-transition"
        scrollable
        persistent
        max-width="700"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text
                class="wrapperFormModal"
            >
                <v-card flat>
                    <v-card-text>
                        
                        <v-form ref="form" lazy-validation>

                            <template v-for="item in fields">
                                <component 
                                    :is="item.field.componentName" 
                                    :key="item.name"
                                    :label="item.field.label" 
                                    :value="item.field.value" 
                                    @input="e => updateField({ property: item.name, value: e })" 
                                    :rules="requiredRule"                                            
                                />
                            </template>
                            
                        </v-form>

                    </v-card-text>
                </v-card>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn 
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                    v-if="isValid"
                >
                    {{ $t("Добавить") }} 
                </v-btn>

                <v-btn
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Отмена") }}
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "CSCCustomAnswerDlg",
    data () {
        return {
            title: "Добавить_исполнение",
            
        }
    },
    computed: {
        ...mapGetters('actionsource', { getDataSource: 'getDataSource'}),
        ...mapGetters('dialogs/cscCustomAnswer', ['isVisible', 'isValid']),
        ...mapGetters({ 
            requiredRule: 'getRequiredRule',
            multipleRule: 'getMultipleRule',
        }),
        fields() {
            return this.$store.getters['dialogs/cscCustomAnswer/fields'];
        }
    },
    methods: {
        ...mapActions('dialogs/cscCustomAnswer', ['ok', 'cancel', 'updateField']),
        validateFormMethod(){
            this.$refs?.form?.validate();    
        }
    }
}
</script>